import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {Tr} from "@/i18n/i18n";
import SpriteUtils from "@/utils/sprite-utils";
import {Keys} from "@/constants/key";
import CU from "@/utils/c-u";
import {InfoPanel} from "@/scenes.ui/info-panel";
import {ArkInfoPanel} from "@/scenes.ui/ark-info-panel";
import PlayerStore from "@/store/player";
import {NewsPanel} from "@/scenes.ui/news-panel";

export class Monastery11InfoPanel extends Phaser.GameObjects.Container {

    public static readonly PANEL_HEIGHT = 90;

    constructor(scene: Phaser.Scene, canvas: HTMLCanvasElement, comment1: string, comment2: string) {
        super(scene);

        this.scene = scene;
        this.height = Monastery11InfoPanel.PANEL_HEIGHT;
        let self = this;

        let back = SpriteUtils.addImage(this.scene, -300, 0, Keys.OBLIVION_BACK_2, undefined).setOrigin(0, 0);

        let yy = 0;
        let help1 = TextUtils.addTextAdvanced(scene, comment1, 0, yy += 30,
            '#a3afc9', 13, 'normal', 480, 'center', 2, Fonts.MYRIADPRO_REGULAR);

        let help2 = TextUtils.addTextAdvanced(scene, comment2, 0, yy += 30,
            '#c5d9cb', 13, 'normal', 480, 'center', 2, Fonts.MYRIADPRO_REGULAR);

        let question2 = SpriteUtils.addImage(this.scene!, help2.getTopRight().x! / CU.S + 14, help2.y / CU.S + 1, Keys.ATLAS_UI, Keys.UI_STAT_MINE_CIRCLE, 0.8, 0.8)
        question2.setInteractive().on('pointerup', function() {

            PlayerStore.getManual('monastery').then(man => {
                let ip: NewsPanel = new NewsPanel(scene, canvas, Tr('manual'), man, () => {
                    ip.close();
                }, false, false);
                ip.openAnimated();
            });
        });

        const separator = SpriteUtils.addSprite(this.scene!, -300, this.height, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR).setOrigin(0, 1);

        this.add([back, help1, question2, help2, separator]);
    }

}
